import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { photoIcon } from '../../icons';
import { useAnimation } from 'framer-motion';
import { AnimationElement } from '../../../../../../../common/Animation';
import { serviceErrorAnimationConfig } from '../../constants';
import { usePublicationUnavailableListener } from '../../../../../../../../hooks/usePublicationUnavailableListener';
import { generateErrorBannerShowAction } from '../../../../../../../../actions/webview';
import { useAppContext } from '../../../../../../../../../AppModulesWrapper';

export interface INoPhotosProps {
  serviceName: string;
}

export const NoPhotos = ({ serviceName }: INoPhotosProps) => {
  const { webview } = useAppContext();
  const animationControls = useAnimation();
  usePublicationUnavailableListener(() => animationControls.start('start'));

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('no-photos-unavailable-reason-banner-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AnimationElement animate={animationControls} {...serviceErrorAnimationConfig}>
      <ErrorWrapper icon={photoIcon}>Добавьте фото, чтобы продвинуть объявление в&nbsp;{serviceName}</ErrorWrapper>
    </AnimationElement>
  );
};
